import { render, staticRenderFns } from "./teachinggrade.vue?vue&type=template&id=d4b166d8&scoped=true&"
import script from "./teachinggrade.vue?vue&type=script&lang=js&"
export * from "./teachinggrade.vue?vue&type=script&lang=js&"
import style0 from "./teachinggrade.vue?vue&type=style&index=0&id=d4b166d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b166d8",
  null
  
)

export default component.exports